import { useState, useEffect, useCallback } from 'react';
import { Trans } from 'react-i18next';
import logger from '@widgets/logger';
import { ControlledToaster } from '@components/Toaster';
import { useTranslation } from '@hooks';
import { appService } from '@services';

const AppVersion = import.meta.env.REACT_APP_VERSION;
logger.info('AppVersion:', AppVersion);
const VERSION_CHECK_INTERVAL = 1000 * 60 * 3; // INFO: 3 minutes

const BumpVersion = () => {
    const { t } = useTranslation();
    const [hasNewVersion, setHasNewVersion] = useState(false);

    const fetchRemoteVersion = useCallback(async () => {
        try {
            const data = await appService.getAppVersion();
            if (data.version !== AppVersion) {
                setHasNewVersion(true);
            }
        } catch (error) {
            logger.error('Unable to fetch remote version', error);
        }
    }, []);

    useEffect(() => {
        fetchRemoteVersion();
        const timer = setInterval(fetchRemoteVersion, VERSION_CHECK_INTERVAL);
        return () => clearInterval(timer);
    }, []);

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') return;
        setHasNewVersion(false);
    };

    const onClickRefresh = () => {
        window.location.reload();
    };

    return (
        <ControlledToaster
            callback={onClickRefresh}
            autoHideDuration={null}
            text={
                <Trans t={t} i18nKey={'SettingsProfile.bumpVersion'}>
                    <b style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={onClickRefresh}>
                        {{ refresh: t('common.refresh') }}
                    </b>
                </Trans>
            }
            type="info"
            open={hasNewVersion}
            setOpen={setHasNewVersion}
            clickClose={handleClose}
        />
    );
};

export default BumpVersion;
